/**
 * trace_id — convenção fixa desta rodada (diagnóstico/observabilidade, ver
 * docs/reports da Rodada 4): a UI gera UM trace_id (UUID v4) por operação de
 * negócio (carregar envelope, autorizar, assinar, baixar) e o envia no header
 * `x-argink-trace-id` em todas as chamadas HTTP daquela operação — API e agente
 * local. Os serviços ecoam o header e passam a incluir `trace_id` no corpo de
 * erro; quando o corpo não traz um (ou a chamada nem saiu, ex. rede/timeout),
 * o trace_id gerado aqui localmente é o que sobra como código de suporte
 * (ver `describeError` em `./errors.ts`).
 */
export function newTraceId(): string {
  return crypto.randomUUID();
}
